import { useGet } from "@/apiHooks/HttpFunctions";
import { FILTER_TYPE } from "@/constant/constants";
import { sportsMasterDataApi } from "@/apis/apis";
import { LIST_MODE } from "@/constant/Lists/listMode";

export const useFilters = () => {
  const { data: sportsData, error: sportsError } = useGet({
    apiURL: `${sportsMasterDataApi}?mode=${LIST_MODE.ALL}`,
  });

  const sportOptions = [
    { label: "All Sport", value: "" },
    ...(sportsData?.data?.map((sport) => ({
      label: sport.name,
      value: "" + sport.id,
    })) || []),
  ];

  // Define the filters
  return [
    {
      id: "filter[sport]",
      label: "Sport",
      type: FILTER_TYPE.SELECT,
      options: sportOptions,
    },
    {
      id: "filter[level]",
      label: "Level",
      type: FILTER_TYPE.SELECT,
      options: [
        { label: "All Level", value: "" },
        { label: "1", value: "1" },
        { label: "2", value: "2" },
      ],
    },
  ];
};
